import React from 'react';
import './ProductDetailHeading.scss';
import { gundamProductNames } from '../../../../own-days/views/desktop/Gundam/gundamHelper';

const ProductDetailHeading = ({ productData, bardNameInfo }) => {
  const { frameColour, frameType, frameShape, type, contactLensPowerFromUrl } = bardNameInfo;
  return (
    <div className="layout justify-content-between align-items-start">
      <div className="od-pdp-brand">
        {productData.brandName && (
          <h2 className="od-pdp-brand__name od-font-reg">{productData.brandName}</h2>
        )}
        {productData.classification === 'eyeframe' ||
        productData.classification === 'sunglasses' ? (
          <h1 className="od-pdp-brand__fullname od-font-bold">
            {gundamProductNames[Number(productData?.id)] ||
              `${frameColour} ${frameType} ${frameShape} ${type}`}
          </h1>
        ) : (
          <h1 className="od-pdp-brand__fullname od-font-bold">
            {gundamProductNames[Number(productData?.id)] ||
              `${productData.title} ${contactLensPowerFromUrl}`}
          </h1>
        )}
      </div>
    </div>
  );
};

export default ProductDetailHeading;
